import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_DEPARTMENTS);

var axios_instance_upload_template = get_axios_instance(
  api_variables.SERVICE_DEPARTMENT_UPLOAD_TEMPLATE
);

const _pk_name = "id";

const state = {
  data: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false,
  editMode: false,
  record:{}
};

const getters = {
  editMode:(state) =>{
    return state.editMode;
  },
  record: (state) => {
    return state.record;
  }
}

const mutations = {
  set: (state, [payload, le_id]) => {
    if (le_id) {
      state.data[le_id] = payload;
      state.data = { ...state.data };
    }
  },

  addEntity: (state, [payload, id]) => {
    if (!state.data[id]) {
      state.data[id] = [payload];
    } else {
      state.data[id].push(payload);
    }
  },

  updateEntityById: (state, [payload, id]) => {
    for(let i=0; i < state.data[id].length; i++) {
      if(state.data[id][i][_pk_name] === payload.id) {
        state.data[id].splice(i, 1, payload);
      }
    }
  },

  removeEntityById: (state, [payload, id]) => {
    for (let i=0; i < state.data[id].length; i++){
      if (state.data[id][i][_pk_name] == payload){
        state.data[id].splice(i, 1);
      }
    }
    if(state.data[id].length==0)
      state.data={}
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
  setEditMode: (state, payload) => {
    state.editMode = payload.editMode;
    state.record = payload.record;
  }
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/onboard/departments/fetchAll] Calling API...:",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
            le_id: payload
          }
      });
      commit("setFetching", false);
      //console.log("[state/onboard/departments/fetchAll] res: ", res);
      if(res.status == 200) {
        if(res.data.payload.data.length!=0)
         commit("set", [res.data.payload.data, payload]);
      }
      return res;
    }catch(error) {
      throw errorHandler(error.response);
    }
  },

  async uploadTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async create({commit}, payload) {
      //console.log("[state/onboard/departments/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/onboard/departments/create] res: ", res);
      if(res.status == 200) {
        commit("addEntity", [res.data.payload, payload.le_id]);
      }
      return res;
    }catch(error) {
      throw errorHandler(error.response);
    }
  },

  async update({commit}, [payload, le_id]) {
      //console.log("[state/onboard/departments/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/`+ payload.id, { data: payload });
      commit("setSaving", false);
      if (res.status == 200) {
          commit("updateEntityById", [res.data.payload, le_id]);
      }
      return res;
    } catch(error) {
      throw errorHandler(error.response);
    }
  },

  async delete({commit}, [payload, id]) {
    //console.log("[state/onboard/departments/delete] Payload:", payload);
    //console.log("[state/onboard/departments/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEntityById", [payload.id, id]);
      }
      return res;
    } catch(error) {
      throw errorHandler(error.response);
    }
  },

  async changeEditMode({ commit }, payload) {
    // //console.log(
    //   "[state/onboard/departments/changeEditMode] Payload:",
    //   payload
    // );
    try {
      commit("setEditMode", payload);
    } catch(err) {
      //console.log(err)
    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions,getters
}
